export default __webpack_public_path__ + "static/media/charte-engagement.7060ec9d.pdf";